var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress } from "@mui/material";
import { colors, theme } from "../../../theme";
var Loader = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b;
    return (_jsx(Backdrop, __assign({ "data-testid": "loading", style: { zIndex: theme.zIndex.drawer + 1, color: colors.white }, open: open }, { children: _jsx(CircularProgress, { color: "inherit" }) })));
};
export { Loader };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9hZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdWkvTG9hZGVyL0xvYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxFQUFFLFFBQVEsRUFBRSxnQkFBZ0IsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUMzRCxPQUFPLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBTS9DLElBQU0sTUFBTSxHQUFHLFVBQUMsRUFBNkI7UUFBM0IsWUFBWSxFQUFaLElBQUksbUJBQUcsS0FBSyxLQUFBO0lBQWlDLE9BQUEsQ0FDN0QsS0FBQyxRQUFRLDRCQUFhLFNBQVMsRUFBQyxLQUFLLEVBQUUsRUFBRSxNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFLEtBQUssRUFBRSxNQUFNLENBQUMsS0FBSyxFQUFFLEVBQUUsSUFBSSxFQUFFLElBQUksZ0JBQ3pHLEtBQUMsZ0JBQWdCLElBQUMsS0FBSyxFQUFDLFNBQVMsR0FBRyxJQUMzQixDQUNaO0FBSjhELENBSTlELENBQUM7QUFFRixPQUFPLEVBQUUsTUFBTSxFQUFFLENBQUMifQ==